<template>

  <div class="edit_sr_page">
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Editing Service Description - {{ serviceRequestStringID }} - {{ workFlowName }}
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <validation-observer
      ref="serviceRequestEditForm"
    >
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col md="8">
            <div ref="service_description">
              <b-card
                v-show="customFields.length > 0"
                class="service-description-plain-card"
              >
                <div
                  v-for="(group, gIndex) in serviceDescriptionGroups"
                  :key="gIndex"
                  class="service-description-fields_group"
                >
                  <b-row
                    v-for="entry in group"
                    :key="entry.key"
                    :class="{ 'field-row-card': entry.opt.type !== 'title-and-text' }"
                  >
                    <b-col cols="12">
                      <div v-if="entry.opt.type == 'title-and-text'">
                        <p class="text-bold-black">
                          {{ entry.opt.label }}
                        </p>
                        <p v-if="serviceDescription[entry.key].text">
                          {{ serviceDescription[entry.key].text }}
                        </p>
                      </div>
                      <b-row
                        v-if="entry.opt.type == 'short-answer'"
                      >
                        <b-col md="12">
                          <div class="block_label">
                            <label
                              class="col-form-label"
                              :for="'event-custom-field-' + entry.key"
                            >{{ entry.opt.label }}</label>
                          </div>
                        </b-col>
                        <b-col md="10">
                          <validation-provider
                            #default="{ errors }"
                            :name="entry.opt.label"
                            :vid="'event-custom-field-' + entry.key"
                            :rules="entry.opt.required == 'yes' ? 'required' : ''"
                          >
                            <b-form-input
                              :id="'event-custom-field-' + entry.key"
                              v-model="serviceDescription[entry.key].value"
                              :placeholder="entry.opt.label"
                              :state="(errors.length > 0) ? false : null"
                              :readonly="!canViewThisAction('update', 'ServiceForm') && !canViewThisAction('update-service-description', 'ServiceForm')"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>

                      <b-row
                        v-if="entry.opt.type == 'long-answer'"
                      >
                        <b-col md="12">
                          <div class="block_label">
                            <label
                              class="col-form-label"
                              :for="'event-custom-field-' + entry.key"
                            >{{ entry.opt.label }}</label>
                          </div>
                        </b-col>
                        <b-col md="10">
                          <validation-provider
                            #default="{ errors }"
                            :name="entry.opt.label"
                            :vid="'event-custom-field-' + entry.key"
                            :rules="entry.opt.required == 'yes' ? 'required' : ''"
                          >
                            <b-form-textarea
                              :id="'event-custom-field-' + entry.key"
                              v-model="serviceDescription[entry.key].value"
                              trim
                              :placeholder="entry.opt.label"
                              :state="(errors.length > 0) ? false : null"
                              :readonly="!canViewThisAction('update', 'ServiceForm') && !canViewThisAction('update-service-description', 'ServiceForm')"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>

                      <div
                        v-if="entry.opt.type == 'increment'"
                        class="d-flex justify-content-between align-items-center field-row-inner"
                      >
                        <label
                          class="mb-0"
                          :for="'event-custom-field-' + entry.key"
                        >{{ entry.opt.label }}</label>
                        <validation-provider
                          #default="{ errors }"
                          :name="entry.opt.label"
                          :vid="'event-custom-field-' + entry.key"
                          :rules="entry.opt.required == 'yes' ? 'required' : ''"
                        >
                          <b-form-spinbutton
                            :id="'event-custom-field-' + entry.key"
                            v-model="serviceDescription[entry.key].value"
                            inline
                            class="spin-button-sd"
                            :state="(errors.length > 0) ? false : null"
                            :step="entry.opt.increments"
                            :min="entry.opt.minQuantity"
                            :max="entry.opt.maxQuantity"
                            :readonly="!canViewThisAction('update', 'ServiceForm') && !canViewThisAction('update-service-description', 'ServiceForm')"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>

                      <b-row
                        v-if="entry.opt.type == 'multi-select' && entry.opt.multiSelectType == 'multiple'"
                        :class="{ 'pointer-none': !canViewThisAction('update', 'ServiceForm') && !canViewThisAction('update-service-description', 'ServiceForm') }"
                      >
                        <b-col md="12">
                          <div class="block_label">
                            <label
                              class="col-form-label"
                              :for="'event-custom-field-' + entry.key"
                            >{{ entry.opt.label }}</label>
                          </div>
                        </b-col>
                        <b-col md="12">
                          <validation-provider
                            #default="{ errors }"
                            :name="entry.opt.label"
                            :rules="entry.opt.required == 'yes' ? 'required' : ''"
                          >

                            <b-form-checkbox-group
                              :id="'event-custom-field-' + entry.key"
                              v-model="serviceDescription[entry.key].value"
                              buttons
                              button-variant="outline-primary"
                              class="spaceBetweenRadio display-block-checkbox"
                            >
                              <b-form-checkbox
                                v-for="(optn, kindex) in entry.opt.extraOptions"
                                :key="kindex"
                                :value="optn.key"
                                class="mb-50 customCheckbox"
                              >
                                <feather-icon
                                  v-if="serviceDescription[entry.key].value.includes(optn.key)"
                                  icon="CheckIcon"
                                  class="mr-50"
                                  size="16"
                                />
                                <span class="align-middle">{{ optn.key }}</span>
                              </b-form-checkbox>
                            </b-form-checkbox-group>

                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>

                      <b-row
                        v-if="entry.opt.type == 'multi-select' && entry.opt.multiSelectType == 'single'"
                        :class="{ 'pointer-none': !canViewThisAction('update', 'ServiceForm') && !canViewThisAction('update-service-description', 'ServiceForm') }"
                      >
                        <b-col md="12">
                          <div class="block_label">
                            <label
                              class="col-form-label"
                              :for="'event-custom-field-' + entry.key"
                            >{{ entry.opt.label }}</label>
                          </div>
                        </b-col>
                        <b-col md="10">
                          <validation-provider
                            #default="{ errors }"
                            :name="entry.opt.label"
                            :rules="entry.opt.required == 'yes' ? 'required' : ''"
                          >
                            <b-form-checkbox-group
                              :id="'event-custom-field-' + entry.key"
                              v-model="serviceDescription[entry.key].value"
                              buttons
                              button-variant="outline-primary"
                              class="spaceBetweenRadio display-block-checkbox"
                              @input="makeCheckboxToRadio(entry.key)"
                            >
                              <b-form-checkbox
                                v-for="(optn, kindex) in entry.opt.extraOptions"
                                :key="kindex"
                                :value="optn.key"
                                class="mb-50 customCheckbox"
                              >
                                <feather-icon
                                  v-if="serviceDescription[entry.key].value.includes(optn.key)"
                                  icon="CheckIcon"
                                  class="mr-50"
                                  size="16"
                                />
                                <span class="align-middle">{{ optn.key }}</span>
                              </b-form-checkbox>
                            </b-form-checkbox-group>

                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>

                      <b-row
                        v-if="entry.opt.type == 'single-select'"
                      >
                        <b-col md="12">
                          <div class="block_label">
                            <label
                              class="col-form-label"
                              :for="'event-custom-field-' + entry.key"
                            >{{ entry.opt.label }}</label>
                          </div>
                        </b-col>
                        <b-col md="10">
                          <validation-provider
                            #default="{ errors }"
                            :name="entry.opt.label"
                            :rules="entry.opt.required == 'yes' ? 'required' : ''"
                          >

                            <b-form-checkbox-group
                              :id="'event-custom-field-' + entry.key"
                              v-model="serviceDescription[entry.key].value"
                              buttons
                              button-variant="outline-primary"
                              class="spaceBetweenRadio display-block-checkbox"
                              :disabled="!canViewThisAction('update', 'ServiceForm') && !canViewThisAction('update-service-description', 'ServiceForm')"
                              @input="makeCheckboxToRadio(entry.key)"
                            >
                              <b-form-checkbox
                                v-for="(optn, kindex) in requiredOptions"
                                :key="kindex"
                                :value="optn.value"
                                class="mb-50 customCheckbox"
                              >
                                <feather-icon
                                  v-if="serviceDescription[entry.key].value.includes(optn.value)"
                                  icon="CheckIcon"
                                  class="mr-50"
                                  size="16"
                                />
                                <span class="align-middle">{{ optn.text }}</span>
                              </b-form-checkbox>
                            </b-form-checkbox-group>

                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>

                      <validation-provider
                        v-if="entry.opt.type == 'dropdown'"
                        #default="{ errors }"
                        :name="entry.opt.label"
                        :vid="'event-custom-field-' + entry.key"
                        :rules="entry.opt.required == 'yes' ? 'required' : ''"
                      >
                        <b-row>
                          <b-col md="12">
                            <div class="block_label">
                              <label
                                class="col-form-label"
                                :for="'event-custom-field-' + entry.key"
                              >{{ entry.opt.label }}</label>
                            </div>
                          </b-col>
                          <b-col md="10">
                            <v-select
                              :id="'event-custom-field-' + entry.key"
                              v-model="serviceDescription[entry.key].value"
                              label="value"
                              placeholder="Select From List"
                              :options="entry.opt.extraOptions"
                              :reduce="value => value.key"
                              :clearable="true"
                              :disabled="!canViewThisAction('update', 'ServiceForm') && !canViewThisAction('update-service-description', 'ServiceForm')"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </b-col>
                        </b-row>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </div>
          </b-col>

          <b-col md="4">
            <b-card class="order-summary-card edit_sd">
              <h4 class="mb-1">
                Order Summary
              </h4>
              <div class="inner_wrapper">
                <div class="added_sd_items" v-if="orderSummaryDiff.added.length || orderSummaryDiff.removed.length">
                  <div class="added_sd_items_inner">
                    <template v-if="orderSummaryDiff.added.length">
                      <div class="inner_group">
                        <p class="text-bold-black mb-50">
                          Added item(s)
                        </p>
                        <div
                          v-for="(item, index) in orderSummaryDiff.added"
                          :key="'added' + index"
                          class="d-flex justify-content-between mb-1"
                        >
                          <span class="qty_box">{{ item.qty }} x</span>
                          <span>{{ item.label }}</span>
                          <span class="text-success text-nowrap ml-1">+ {{ formatCurrency(item.amount) }}</span>
                        </div>
                      </div>
                    </template>

                    <template v-if="orderSummaryDiff.removed.length">
                      <div class="inner_group">
                        <p class="text-bold-black mb-50">
                          Removed item(s)
                        </p>
                        <div
                          v-for="(item, index) in orderSummaryDiff.removed"
                          :key="'removed' + index"
                          class="d-flex justify-content-between mb-1"
                        >
                          <span class="qty_box">{{ item.qty }} x</span>
                          <span>{{ item.label }}</span>
                          <span class="text-danger text-nowrap ml-1">– {{ formatCurrency(item.amount) }}</span>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="d-flex justify-content-between or_order_total">
                  <span>Original Order Total</span>
                  <span>{{ formatCurrency(originalOrderTotal) }}</span>
                </div>
                <div
                  v-if="additionalPaymentRequired !== 0"
                  class="d-flex justify-content-between font-weight-bold"
                >
                  <span>Updated Order Total</span>
                  <span>{{ formatCurrency(updatedOrderTotal) }}</span>
                </div>
                <div
                  v-else
                  class="d-flex justify-content-between empty_extra_item"
                >
                  <div class="inner_empty_box">
                    <div>No change to total</div>
                    <div>—</div>
                  </div>
                </div>

                <div
                  v-if="additionalPaymentRequired > 0"
                  class="order-summary-highlight-box mt-1 mb-1"
                >
                  <div class="summary_highlight_box_inner">
                    <p class="mb-0 text-bold-black">
                      Additional Payment Required
                    </p>
                    <h3 class="mb-0">
                      {{ formatCurrency(additionalPaymentRequired) }}
                    </h3>
                    <p class="text-muted mb-0">
                      {{ formatCurrency(originalOrderTotal) }} <span>→</span> {{ formatCurrency(updatedOrderTotal) }} • <small>Incl. 9% GST</small>
                    </p>
                  </div>
                </div>

                <div class="d-flex justify-content-between mt-1">
                  <span>Amount Paid</span>
                  <span>{{ formatCurrency(amountPaid) }}</span>
                </div>

                <div class="d-flex justify-content-between mt-2">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="button"
                    variant="flat-primary"
                    :to="{ name: 'operation-service-requests-show', params: { id: $route.params.id } }"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                  >
                    <span class="align-middle">Save & Update Order</span>
                  </b-button>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormInput, BForm, BButton, BFormTextarea,
  BFormCheckboxGroup, BFormCheckbox, BFormSpinbutton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required, min } from '@validations'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BButton,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSpinbutton,
    BFormTextarea,

    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      canViewThisAction,
      savedData: false,
      workFlow: '',
      serviceForm: this.$route.query.form || '',
      date: '',
      time: '',
      location: '',
      fileNo: '',
      remarks: '',
      status: 'pending',
      assignees: [],
      workFlowError: 'Valid workFlow is required',
      workFlowValidation: false,
      serviceFormError: 'Valid serviceForm is required',
      serviceFormValidation: false,
      dateError: 'Valid date is required',
      dateValidation: false,
      timeError: 'Valid time is required',
      timeValidation: false,
      locationError: 'Valid location is required',
      locationValidation: false,
      remarksError: 'Valid remarks is required',
      remarksValidation: false,
      assigneesError: 'Valid assignees is required',
      assigneesValidation: false,
      statusError: 'Valid status is required',
      statusValidation: false,
      option: [{ title: 'Pending', code: 'pending' }, { title: 'Completed', code: 'completed' }],
      workFlowOptions: [],
      serviceFormOptions: [],
      userOptions: [],
      flatPickrConfigWithoutTime: {
        wrap: true, enableTime: false, dateFormat: 'd/m/Y', disableMobile: true,
      },
      flatPickrConfigTime: {
        wrap: true, noCalendar: true, enableTime: true, dateFormat: 'H:i', disableMobile: true,
      },
      assignmentError: false,
      alreadyCheckedSchedule: false,
      assignmentErrorOptions: [],
      serviceDescription: [],
      customFields: [],
      tagProductOptions: [],
      serviceDescriptionSetId: null,
      serviceRequestStringID: '',
      relatedOrder: null,
      previousValues: [],
      venueField: '',
      titleFields: '',
      requiredOptions: [
        { text: 'Yes', value: 'yes' },
        { text: 'No', value: 'no' },
      ],
      paymentStatus: 'N/A',
      paymentStatusError: '',
      paymentStatusValidation: false,
      paymentRemarks: '',
      paymentRemarksError: 'Valid value is required',
      paymentRemarksValidation: false,
      ntrNo: '',
      ntrNoError: 'Valid value is required',
      ntrNoValidation: false,
      paymentStatusOptions: [
        { title: 'Paid', code: 'Paid' },
        { title: 'Partially Paid', code: 'Partially Paid' },
        { title: 'Unpaid', code: 'Unpaid' },
        { title: 'FSP', code: 'FSP' },
        { title: 'N/A', code: 'N/A' },
      ],

      // validation rules
      required,
      min,
    }
  },
  computed: {
    serviceDescriptionGroups() {
      const nodeMap = new Map()
      this.customFields.forEach((field, key) => {
        nodeMap.set(field.id, { opt: field, key, children: [] })
      })

      const roots = []
      this.customFields.forEach(field => {
        const node = nodeMap.get(field.id)
        const parentNode = field.parent && nodeMap.get(field.parent)
        if (parentNode) {
          parentNode.children.push(node)
        } else {
          roots.push(node)
        }
      })

      const flattenNode = (node, out) => {
        out.push({ opt: node.opt, key: node.key })
        node.children.forEach(child => flattenNode(child, out))
      }

      return roots.map(root => {
        const out = []
        flattenNode(root, out)
        return out
      })
    },
    workFlowName() {
      const match = this.workFlowOptions.find(o => o._id === this.workFlow)
      return match ? match.name : ''
    },
    originalOrderTotal() {
      return this.relatedOrder ? this.relatedOrder.total : 0
    },
    amountPaid() {
      return this.relatedOrder ? this.relatedOrder.amountPaid : 0
    },
    orderSummaryDiff() {
      const added = []
      const removed = []

      this.serviceDescription.forEach(current => {
        const previous = this.previousValues.find(o => o.id === current.id) || this.previousValues.find(o => o.key === current.key)
        const field = this.customFields.find(f => f.id === current.id)

        if (current.type === 'increment') {
          const newQty = Number(current.value) || 0
          const oldQty = previous ? Number(previous.value) || 0 : 0
          const price = this.resolveFieldPrice(field, current.key)
          if (newQty > oldQty) {
            added.push({
              qty: newQty - oldQty, label: current.key, amount: price * (newQty - oldQty),
            })
          } else if (newQty < oldQty) {
            removed.push({
              qty: oldQty - newQty, label: current.key, amount: price * (oldQty - newQty),
            })
          }
        } else if (current.type === 'multi-select' || current.type === 'single-select') {
          const newVals = Array.isArray(current.value) ? current.value : []
          const oldRaw = previous ? previous.value : []
          let oldVals = []
          if (Array.isArray(oldRaw)) {
            oldVals = oldRaw
          } else if (oldRaw) {
            oldVals = [oldRaw]
          }

          newVals.filter(v => !oldVals.includes(v)).forEach(v => {
            added.push({ qty: 1, label: v, amount: this.resolveFieldPrice(field, v) })
          })
          oldVals.filter(v => !newVals.includes(v)).forEach(v => {
            removed.push({ qty: 1, label: v, amount: this.resolveFieldPrice(field, v) })
          })
        }
      })

      return { added, removed }
    },
    updatedOrderTotal() {
      const addedTotal = this.orderSummaryDiff.added.reduce((sum, item) => sum + item.amount, 0)
      const removedTotal = this.orderSummaryDiff.removed.reduce((sum, item) => sum + item.amount, 0)
      return this.originalOrderTotal + addedTotal - removedTotal
    },
    additionalPaymentRequired() {
      return this.updatedOrderTotal - this.originalOrderTotal
    },
  },
  watch: {
    assignees() {
      this.checkForAssigneeSchedule()
    },
  },
  async beforeMount() {
    this.$http.get('products/retail-items/respond-with/name-and-id')
      .then(response => {
        this.tagProductOptions = response.data.stores || []
      })
      .catch(() => {})

    await this.$http.get(`operation/service-requests/${this.$route.params.id}`)
      .then(response => {
        this.serviceForm = response.data.serviceForm || ''
        this.workFlow = response.data.workFlow || ''
        this.date = `${this.dateFormat(response.data.date)}` || ''
        this.time = `${this.twentyFourHourTimeFormatFromDateString(response.data.date)}` || ''
        this.location = response.data.location || ''
        this.remarks = response.data.remarks || ''
        this.fileNo = response.data.fileNo || ''
        this.status = response.data.status || 'pending'
        this.paymentRemarks = response.data.paymentRemarks || ''
        this.ntrNo = response.data.ntrNo || ''
        this.paymentStatus = response.data.paymentStatus || 'N/A'
        this.assignees = response.data.assignees || []
        this.previousValues = response.data.serviceDescription || []
        this.serviceRequestStringID = response.data.stringID || ''
        this.serviceDescriptionSetId = response.data.serviceDescriptionSet || null

        document.title = `Editing ${response.data.stringID} | ${process.env.VUE_APP_APP_NAME || 'Nirvana Memorial Garden'}`
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })

    this.relatedOrder = await this.findRelatedOrder()

    this.$http.get('operation/service-requests/respond-with/extra-options', { params: { department: true } })
      .then(async response => {
        const workFlowCats = response.data.workFlowCats ?? []
        this.serviceFormOptions = response.data.serviceFormOptions ?? []
        this.userOptions = response.data.userOptions ?? []
        this.venueField = response.data.venueField ?? ''
        this.titleFields = response.data.titleFields ?? ''

        workFlowCats.forEach(element => {
          this.workFlowOptions.push({
            category: element.name,
            name: null,

            _id: element._id,
          })
          element.workFlows.forEach(flow => {
            this.workFlowOptions.push({
              name: flow.name,

              _id: flow._id,
            })
          })
        })

        // Prefer the exact ServiceDescriptionSet this service request was created from
        // (operations/service-description-setups) over the legacy global ServiceDescription
        // doc, so editing shows the same fields the customer/agent actually filled in.
        let sourceCustomFields = []
        if (this.serviceDescriptionSetId) {
          try {
            const setResponse = await this.$http.get(`operation/service-description-setups/${this.serviceDescriptionSetId}/show`)
            sourceCustomFields = (setResponse.data.data && setResponse.data.data.items) || []
          } catch (err) {
            sourceCustomFields = []
          }
        } else {
          const { serviceDescription } = response.data
          sourceCustomFields = serviceDescription ? (serviceDescription.customFields || []) : []
        }

        // The two sources shape Quantity fields differently: the legacy editor stores
        // min/max/step as extraOptions[0/1/2], the ServiceDescriptionSet builder stores
        // them as top-level minQuantity/maxQuantity/increments. Normalize once here so
        // the rest of this component (and the template) only deals with one shape.
        const normalizedFields = sourceCustomFields.map(field => {
          if (field.type !== 'increment' || (field.minQuantity !== undefined && field.minQuantity !== null)) {
            return field
          }
          const opts = field.extraOptions || []
          return {
            ...field,
            minQuantity: opts[0] ? opts[0].value : 0,
            maxQuantity: opts[1] ? opts[1].value : 0,
            increments: opts[2] ? opts[2].value : 1,
          }
        })

        if (normalizedFields.length) {
          this.serviceDescription = normalizedFields.map(arrayItem => this.buildServiceDescriptionValue(arrayItem))
        }
        this.customFields = normalizedFields

        await this.$nextTick()
        const { section } = this.$route.query
        if (section) {
          const element = this.$refs[section]
          if (element) {
            const top = element.offsetTop - 135
            window.scrollTo({
              top,
              behavior: 'smooth',
            })
          }
        }
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  beforeRouteLeave(to, from, next) {
    if (!this.savedData) {
      this.$swal({
        title: 'Unsaved Changes - Leave?',
        html: 'You have unsaved changes. Are you sure you want to leave this page?',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: "Yes, I'm Sure",
        cancelButtonText: 'No, Go Back',
        customClass: {
          confirmButton: 'btn btn-outline-primary no-focus-bg ml-1',
          cancelButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            next()
          } else {
            next(false)
          }
        })
    } else {
      next()
    }
  },
  methods: {
    // Builds one serviceDescription value entry for a field definition, preferring the
    // request's own previously-submitted value (matched by id, falling back to label)
    // over the field's default, so re-opening this page doesn't reset existing answers.
    buildServiceDescriptionValue(arrayItem) {
      const newObj = {}
      newObj.key = arrayItem.label
      newObj.type = arrayItem.type
      newObj.id = arrayItem.id
      newObj.parent = arrayItem.parent
      const exist = this.previousValues.find(o => o.id === arrayItem.id)
      const old = this.previousValues.find(o => o.key === arrayItem.label)
      const source = exist || old
      if (source) {
        if (arrayItem.type === 'multi-select' || arrayItem.type === 'single-select') {
          newObj.value = Array.isArray(source.value) ? (source.value || []) : ([source.value] || [])
        } else if (arrayItem.type === 'title-and-text') {
          newObj.value = ''
          newObj.text = arrayItem.description
        } else if (arrayItem.type === 'increment') {
          newObj.value = +source.value
        } else {
          newObj.value = source.value || ''
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (arrayItem.type === 'multi-select' || arrayItem.type === 'single-select') {
          newObj.value = []
        } else if (arrayItem.type === 'title-and-text') {
          newObj.value = ''
          newObj.text = arrayItem.description
        } else if (arrayItem.type === 'increment') {
          newObj.value = +arrayItem.minQuantity
        } else {
          newObj.value = ''
        }
      }
      return newObj
    },
    extractPrice(label) {
      const match = String(label).match(/S?\$\s?([\d,]+(?:\.\d+)?)/)
      return match ? parseFloat(match[1].replace(/,/g, '')) : 0
    },
    // Prefers the real price of the field's (or, for multi-select/dropdown, the selected
    // option's) tagged Catalog Product and falls back to parsing a "$xx" amount out of the
    // legacy label text - mirrors resolveLinePrices() in the backend's retail-order-payment
    // helper, which is the actual source of truth for what gets charged.
    resolveFieldPrice(field, value) {
      let tagProduct = null
      if (field) {
        if (field.type === 'increment') {
          tagProduct = field.tagProduct
        } else if (field.type === 'single-select') {
          tagProduct = value === 'yes' ? field.tagProduct : null
        } else if (field.type === 'multi-select' || field.type === 'dropdown') {
          const matchedOption = (field.extraOptions || []).find(o => o.key === value)
          tagProduct = matchedOption ? matchedOption.tagProduct : null
        }
      }
      if (tagProduct) {
        const product = this.tagProductOptions.find(o => o._id === tagProduct)
        if (product && product.unitPrice !== undefined && product.unitPrice !== null) return product.unitPrice
      }
      return this.extractPrice(value)
    },
    formatCurrency(amount) {
      return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    },
    findRelatedOrder() {
      return this.$http.get('sales/retail-orders', { params: { relatedServiceRequest: this.$route.params.id, perPage: 1 } })
        .then(response => (response.data.retailOrders || [])[0] || null)
        .catch(() => null)
    },
    redirectToRelatedOrder() {
      this.findRelatedOrder()
        .then(relatedOrder => {
          if (relatedOrder) {
            this.$router.push({
              name: 'customers-orders-show',
              params: { id: relatedOrder._id },
              query: { updated: '1' },
            })
          } else {
            this.$router.push({ name: 'operation-service-requests-show', params: { id: this.$route.params.id } })
          }
        })
    },
    checkForAssigneeSchedule() {
      // this.bulkAssigneeValidation === true ? this.bulkAssigneeValidation = false : null
      const formData = new FormData()
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.assignees.length; i++) {
        formData.append('bulkAssignee[]', this.assignees[i])
      }

      formData.append('dueDate', this.date)
      if (this.assignees.length && this.date) {
        this.$http.post('operation/service-requests/task/check/assignee/schedule', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(response => {
            if (response.data.assigneeWarning.length) {
              this.assignmentErrorOptions = response.data.assigneeWarning
              this.assignmentError = true
              // this.$refs['service-request-task-update-modal'].toggle('#toggle-btn')
            } else {
              this.assignmentErrorOptions = []
              this.assignmentError = false
              // this.alreadyCheckedSchedule = true
              // this.$refs['service-request-task-update-modal'].toggle('#toggle-btn')
              // this.submitTaskData()
            }
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      } else {
        this.assignmentErrorOptions = []
        this.assignmentError = false
      }
    },
    cancelEdit() {
      this.$swal({
        title: 'Are you sure?',
        html: 'Selecting Cancel will <strong>undo any changes</strong> you have made. This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, Cancel!',
        cancelButtonText: 'No, Go Back',
        customClass: {
          confirmButton: 'btn btn-danger ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.$router.push({ name: 'operation-service-requests-index', params: { type: 'all-service-requests' } })
          }
        })
    },
    resolveUserName(user) {
      const type = this.userOptions.find(o => o._id === user)
      if (type) {
        return type.name
      }
      return ''
    },
    makeCheckboxToRadio(key) {
      const lastSelected = this.serviceDescription[key].value.slice(-1)[0]
      if (lastSelected) {
        this.serviceDescription[key].value = this.serviceDescription[key].value.filter(code => code === lastSelected)
      }
    },
    submitForm() {
      this.$refs.serviceRequestEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()

          formData.append('serviceForm', this.serviceForm)
          formData.append('workFlow', this.workFlow)
          formData.append('date', this.date)
          formData.append('time', this.time)
          formData.append('location', this.location)
          formData.append('remarks', this.remarks)
          formData.append('fileNo', this.fileNo)
          formData.append('status', this.status)
          formData.append('paymentRemarks', this.paymentRemarks)
          formData.append('ntrNo', this.ntrNo)
          formData.append('paymentStatus', this.paymentStatus)
          formData.append('serviceDescription', JSON.stringify(this.serviceDescription))
          const serviceDescriptionValues = []
          let showServiceDescription = false
          let serviceDescriptionTitle = ''
          const titleArray = this.titleFields.split(',')
          this.serviceDescription.forEach(obj => {
            if (!obj.parent) {
              // sortedData.push(obj)
              const children = this.serviceDescription.filter(o => o.parent === obj.id)
              if (children.length) {
                const childrenArray = []
                children.forEach(opt => {
                  if (opt.type === 'title-and-text') {
                    const child = {
                      id: opt.id,
                      parent: opt.parent,
                      key: opt.key,
                      type: opt.type,
                      text: opt.text,
                      value: '',
                    }
                    childrenArray.push(child)
                  } else if (Array.isArray(opt.value)) {
                    if (opt.value.length) {
                      const child = {
                        id: opt.id,
                        parent: opt.parent,
                        key: opt.key,
                        type: opt.type,
                        value: opt.value,
                      }
                      childrenArray.push(child)
                      showServiceDescription = true
                      if (titleArray.includes(opt.key)) {
                        if (serviceDescriptionTitle === '') {
                          serviceDescriptionTitle += `${opt.value.join(', ')}`
                        } else {
                          serviceDescriptionTitle += `+${opt.value.join(', ')}`
                        }
                      }
                    }
                  } else if (opt.value) {
                    if (opt.type === 'increment' && Number(opt.value) !== 0) {
                      const child = {
                        id: opt.id,
                        parent: opt.parent,
                        key: opt.key,
                        type: opt.type,
                        value: `x${opt.value}`,
                      }
                      childrenArray.push(child)
                      showServiceDescription = true
                      if (titleArray.includes(obj.key)) {
                        if (serviceDescriptionTitle === '') {
                          serviceDescriptionTitle += `${opt.key} x${opt.value}`
                        } else {
                          serviceDescriptionTitle += ` ${opt.key} x${opt.value}`
                        }
                      }
                    } else {
                      const child = {
                        id: opt.id,
                        parent: opt.parent,
                        key: opt.key,
                        type: opt.type,
                        value: opt.value,
                      }
                      childrenArray.push(child)
                      showServiceDescription = true
                      if (titleArray.includes(obj.key)) {
                        if (serviceDescriptionTitle === '') {
                          serviceDescriptionTitle += `${opt.key} ${opt.value}`
                        } else {
                          serviceDescriptionTitle += ` ${opt.key} ${opt.value}`
                        }
                      }
                    }
                  }
                })
                const parent = {
                  id: obj.id,
                  parent: obj.parent,
                  key: obj.key,
                  type: obj.type,
                  text: obj.text,
                  value: obj.value,
                  children: childrenArray,
                }
                serviceDescriptionValues.push(parent)
              } else {
                // eslint-disable-next-line no-lonely-if
                if (obj.type === 'title-and-text') {
                  const parent = {
                    id: obj.id,
                    parent: obj.parent,
                    key: obj.key,
                    type: obj.type,
                    text: obj.text,
                    value: '',
                  }
                  serviceDescriptionValues.push(parent)
                } else if (Array.isArray(obj.value)) {
                  if (obj.value.length) {
                    const parent = {
                      id: obj.id,
                      parent: obj.parent,
                      key: obj.key,
                      type: obj.type,
                      value: obj.value,
                    }
                    serviceDescriptionValues.push(parent)
                    showServiceDescription = true
                    if (titleArray.includes(obj.key)) {
                      if (serviceDescriptionTitle === '') {
                        serviceDescriptionTitle += `${obj.value.join(', ')}`
                      } else {
                        serviceDescriptionTitle += `+${obj.value.join(', ')}`
                      }
                    }
                  }
                } else if (obj.value) {
                  if (obj.type === 'increment' && Number(obj.value) !== 0) {
                    const parent = {
                      id: obj.id,
                      parent: obj.parent,
                      key: obj.key,
                      type: obj.type,
                      value: `x${obj.value}`,
                    }
                    serviceDescriptionValues.push(parent)
                    showServiceDescription = true
                    if (titleArray.includes(obj.key)) {
                      if (serviceDescriptionTitle === '') {
                        serviceDescriptionTitle += `${obj.key} x${obj.value}`
                      } else {
                        serviceDescriptionTitle += ` ${obj.key} x${obj.value}`
                      }
                    }
                  } else {
                    const parent = {
                      id: obj.id,
                      parent: obj.parent,
                      key: obj.key,
                      type: obj.type,
                      value: obj.value,
                    }
                    serviceDescriptionValues.push(parent)
                    showServiceDescription = true
                    if (titleArray.includes(obj.key)) {
                      if (serviceDescriptionTitle === '') {
                        serviceDescriptionTitle += `${obj.key} ${obj.value}`
                      } else {
                        serviceDescriptionTitle += ` ${obj.key} ${obj.value}`
                      }
                    }
                  }
                }
              }
            }
          })
          formData.append('serviceDescriptionValues', JSON.stringify(serviceDescriptionValues))
          formData.append('showServiceDescription', showServiceDescription)
          formData.append('serviceDescriptionTitle', serviceDescriptionTitle)
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.assignees.length; i++) {
            formData.append('assignees[]', this.assignees[i])
          }

          this.$http.patch(`operation/service-requests/${this.$route.params.id}/update`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(response => {
              if (response.data.data) {
                this.$swal({
                  title: 'Order has been updated',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  width: 400,
                  showCancelButton: false,
                  showConfirmButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
                  .then(() => {
                    this.savedData = true
                    this.redirectToRelatedOrder()
                  })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: response.data.message || '',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'serviceForm') {
                    this.serviceFormError = validationError.msg
                    this.serviceFormValidation = true
                  } else if (validationError.param === 'workFlow') {
                    this.workFlowError = validationError.msg
                    this.workFlowValidation = true
                  } else if (validationError.param === 'date') {
                    this.dateError = validationError.msg
                    this.dateValidation = true
                  } else if (validationError.param === 'time') {
                    this.timeError = validationError.msg
                    this.timeValidation = true
                  } else if (validationError.param === 'location') {
                    this.locationError = validationError.msg
                    this.locationValidation = true
                  } else if (validationError.param === 'remarks') {
                    this.remarksError = validationError.msg
                    this.remarksValidation = true
                  } else if (validationError.param === 'assignees') {
                    this.assigneesError = validationError.msg
                    this.assigneesValidation = true
                  } else if (validationError.param === 'status') {
                    this.statusError = validationError.msg
                    this.statusValidation = true
                  }
                })

                const items = document.getElementsByClassName('text-danger')
                window.scrollTo({
                  top: items[0].offsetTop,
                  behavior: 'smooth',
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        } else {
          const items = document.getElementsByClassName('is-invalid')
          if (items && items.length) {
            // window.scrollTo({
            //   top: items[0].offsetHeight + 100,
            //   behavior: 'smooth',
            // })
            items[0].scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            })
          }
        }
      })
    },
  },
}
</script>
